import { mapState } from "vuex";
import config from "@/service/config.js";
export default {
  computed: {
    ...mapState('user', [
        'teamId',
        'token'
    ]),
    ...mapState([
      "currentVersion",
      "env$"
    ])
  },
  methods: {
    async initSocket () {
      await this.initToolSocket()
      
      
      console.log("web-socket create ~~~", this.b$)
    },
    async handleOpenEvent () {
      if (this.currentVersion === "public") {
        await this.apiCallGetPublicCredentials("tool")
      }
      const { sessionToken } = this.b$.tool.store
      const data = { sessionToken }
      const { gen } = await this.b$.send("tool", { cmd: "login", data })
      this.$root.isSocketInited = true
      gen.next()
    },
    async apiCallGetWebsocketCredentials (tag) {
      const result = await this.b$[tag].api
        .getDevelopToolWebsocketSessionCredentials({
          headers: {
            Authorization: "Bearer " + this.token
          },
          query: {
            type: "codeLab",
            customerId: this.teamId
          }
        })
        .catch(err => {
          console.error(err);
          return Promise.reject(err);
        })
      await this.b$.assignment(tag, {
        store: { ...result.body.data, customerId: this.teamId, ver: "v1" }
      })
    },
    
    async apiCallGetPublicCredentials(tag) {
      let result = await this.b$[tag].api.getDevelopToolPublicWebsocketSessionCredentials({
        query: {
            type: 'codeLab'
        },
      }).catch(err => {
        console.error(err);
        return Promise.reject(err);
      })
      await this.b$.assignment(tag, {
        store: { ...result.body.data }
      })
    },
    async initToolSocket () {
      const tag = "tool"
      const { webSocketProtocol, toolConnectionWebsocketUrl } = config;
      const url = webSocketProtocol + toolConnectionWebsocketUrl;
      await this.b$.create(tag, window.nuwa["CodeLab"], { env: config.env,  opts$: { reconnectSetting: { maxReconnectAttempts: 3 } } });
      await this.b$.start("tool", url, "ws.open", this.handleOpenEvent);
    },
    async initWhiteSocket () {
      return await this.b$.create('white', window.nuwa["ListConnection"], {
        env: config.env, opts$: { reconnectSetting: { maxReconnectAttempts: 3 } },
      })
    },
    async initRmsSocket () {
      await this.b$.create("rms", window.nuwa["RmsConnection"], { env: config.env,  opts$: { reconnectSetting: { maxReconnectAttempts: 3 } } })
    },
    async initQuickSocket () {
      const tag = "quick"
      return await this.b$.create(tag, window.nuwa["QuickConnection"], {
        env: config.env, opts$: { reconnectSetting: { maxReconnectAttempts: 3 } },
      })
    },
    async destoryedSocket () {
      ['rms', 'tool', 'quick'].forEach(feo => {
        this.b$.destroy(feo)
      })
    }
  }
}
  